export const convert_to_2_digit = (val) => {
    return val > 9 ? val : "0" + val;
}

const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export const formatDate = (t_d) => {
    const d = new Date(t_d);
    return d.getDate() + " " + months[d.getMonth()] + " at " + convert_to_2_digit(d.getHours()) + ":" + convert_to_2_digit(d.getMinutes());
}

export const getDurationExercise= (exercise) => {
        const d_start = new Date(exercise.te_date + " " + exercise.te_start_time);
        const d_end = new Date(exercise.te_date + " " + exercise.te_end_time);
        return ((d_end - d_start) / (1000 * 60));
}

export const getDurationTS = (exercises) => {
    var duration = 0;

    for (let i = 0; i < exercises.length; i++) {
        duration += getDurationExercise(exercises[i]);
    }
    return duration;
}